import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import API from '../../utils/api';
import toast from 'react-hot-toast';

const st = {
  label: { fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4, display: 'block' },
  input: { padding: '8px 12px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 13, outline: 'none', background: 'white', width: '100%', boxSizing: 'border-box' },
};

export default function Proveedores() {
  const { puedeVer } = useAuth();
  const esAdmin = puedeVer('gerencia', 'administracion');

  const [proveedores, setProveedores] = useState([]);
  const [busqueda, setBusqueda]       = useState('');
  const [modal, setModal]             = useState(false);
  const [editando, setEditando]       = useState(null);
  const [guardando, setGuardando]     = useState(false);
  const [form, setForm] = useState({ nombre:'', nit:'', telefono:'', contacto:'', ciudad:'', notas:'' });

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    API.get('/proveedores').then(r => setProveedores(r.data)).catch(() => {});
  };

  const abrirNuevo = () => {
    setEditando(null);
    setForm({ nombre:'', nit:'', telefono:'', contacto:'', ciudad:'', notas:'' });
    setModal(true);
  };

  const abrirEditar = (p) => {
    setEditando(p.id);
    setForm({ nombre:p.nombre, nit:p.nit||'', telefono:p.telefono||'', contacto:p.contacto||'', ciudad:p.ciudad||'', notas:p.notas||'' });
    setModal(true);
  };

  const guardar = async () => {
    if (!form.nombre) { toast.error('El nombre es requerido'); return; }
    setGuardando(true);
    try {
      if (editando) { await API.put(`/proveedores/${editando}`, form); toast.success('Proveedor actualizado'); }
      else          { await API.post('/proveedores', form);            toast.success('Proveedor creado'); }
      setModal(false); cargar();
    } catch { toast.error('Error al guardar'); }
    finally { setGuardando(false); }
  };

  const desactivar = async (id) => {
    if (!window.confirm('¿Desactivar este proveedor?')) return;
    try { await API.delete(`/proveedores/${id}`); toast.success('Desactivado'); cargar(); }
    catch { toast.error('Error'); }
  };

  const filtrados = proveedores.filter(p =>
    p.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
    (p.nit||'').includes(busqueda) ||
    (p.ciudad||'').toLowerCase().includes(busqueda.toLowerCase())
  );

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: '#111827' }}>🏭 Proveedores</h1>
        <p style={{ margin: '4px 0 0', color: '#6B7280', fontSize: 14 }}>Catálogo de proveedores de Gelatus</p>
      </div>

      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>
        <input value={busqueda} onChange={e => setBusqueda(e.target.value)} placeholder="Buscar por nombre, NIT o ciudad..."
          style={{ ...st.input, maxWidth: 320 }} />
        <div style={{ marginLeft: 'auto', fontSize: 13, color: '#6B7280' }}>{filtrados.length} proveedores</div>
        {esAdmin && (
          <button onClick={abrirNuevo} style={{ padding:'8px 18px', background:'#2563EB', color:'white', border:'none', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700 }}>
            + Nuevo proveedor
          </button>
        )}
      </div>

      <div style={{ background:'white', borderRadius:14, overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.07)' }}>
        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
          <thead>
            <tr style={{ background:'#F9FAFB' }}>
              {['Nombre / Razón social','NIT','Ciudad','Teléfono','Contacto','Facturas',''].map(h => (
                <th key={h} style={{ padding:'10px 14px', textAlign: h==='Facturas'?'right':'left', fontSize:11, fontWeight:700, color:'#6B7280', textTransform:'uppercase' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtrados.length === 0 ? (
              <tr><td colSpan={7} style={{ padding:32, textAlign:'center', color:'#9CA3AF' }}>
                {busqueda ? 'Sin resultados para esa búsqueda' : 'No hay proveedores registrados'}
              </td></tr>
            ) : filtrados.map((p, i) => (
              <tr key={p.id} style={{ borderTop:'1px solid #F3F4F6', background: i%2===0?'white':'#FAFAFA' }}>
                <td style={{ padding:'10px 14px', fontWeight:700 }}>{p.nombre}</td>
                <td style={{ padding:'10px 14px', color:'#6B7280', fontFamily:'monospace' }}>{p.nit||'—'}</td>
                <td style={{ padding:'10px 14px', color:'#6B7280' }}>{p.ciudad||'—'}</td>
                <td style={{ padding:'10px 14px', color:'#6B7280' }}>{p.telefono||'—'}</td>
                <td style={{ padding:'10px 14px', color:'#6B7280' }}>{p.contacto||'—'}</td>
                <td style={{ padding:'10px 14px', textAlign:'right', color:'#374151', fontFamily:'monospace' }}>{p.total_facturas||0}</td>
                <td style={{ padding:'10px 14px' }}>
                  {esAdmin && (
                    <div style={{ display:'flex', gap:6 }}>
                      <button onClick={() => abrirEditar(p)} style={{ padding:'4px 10px', border:'1px solid #E5E7EB', borderRadius:6, background:'white', cursor:'pointer', fontSize:12 }}>✏️ Editar</button>
                      <button onClick={() => desactivar(p.id)} style={{ padding:'4px 10px', border:'1px solid #FECACA', borderRadius:6, background:'white', color:'#EF4444', cursor:'pointer', fontSize:12 }}>Desactivar</button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div style={{ background:'white', borderRadius:16, width:'100%', maxWidth:500 }}>
            <div style={{ background:'#1a1a2e', padding:'14px 22px', borderRadius:'16px 16px 0 0', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span style={{ color:'white', fontWeight:800 }}>🏭 {editando ? 'Editar proveedor' : 'Nuevo proveedor'}</span>
              <button onClick={() => setModal(false)} style={{ background:'none', border:'none', color:'white', fontSize:20, cursor:'pointer' }}>×</button>
            </div>
            <div style={{ padding:22, display:'flex', flexDirection:'column', gap:12 }}>
              <div><span style={st.label}>Nombre / Razón social *</span><input value={form.nombre} onChange={e => setForm(f=>({...f,nombre:e.target.value}))} placeholder="Nombre o razón social" style={st.input} /></div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                <div><span style={st.label}>NIT</span><input value={form.nit} onChange={e => setForm(f=>({...f,nit:e.target.value}))} placeholder="900.000.000-0" style={st.input} /></div>
                <div><span style={st.label}>Ciudad</span><input value={form.ciudad} onChange={e => setForm(f=>({...f,ciudad:e.target.value}))} placeholder="Ciudad" style={st.input} /></div>
                <div><span style={st.label}>Teléfono</span><input value={form.telefono} onChange={e => setForm(f=>({...f,telefono:e.target.value}))} placeholder="Teléfono" style={st.input} /></div>
                <div><span style={st.label}>Contacto</span><input value={form.contacto} onChange={e => setForm(f=>({...f,contacto:e.target.value}))} placeholder="Nombre contacto" style={st.input} /></div>
              </div>
              <div><span style={st.label}>Notas</span><input value={form.notas} onChange={e => setForm(f=>({...f,notas:e.target.value}))} placeholder="Observaciones" style={st.input} /></div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:4 }}>
                <button onClick={() => setModal(false)} style={{ padding:'9px 18px', border:'2px solid #E5E7EB', borderRadius:10, background:'white', cursor:'pointer', fontSize:13 }}>Cancelar</button>
                <button onClick={guardar} disabled={guardando} style={{ padding:'9px 24px', border:'none', borderRadius:10, background:'#2563EB', color:'white', cursor:'pointer', fontSize:13, fontWeight:700 }}>
                  {guardando ? '⏳' : editando ? '💾 Actualizar' : '💾 Crear'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
